import { connect } from 'react-redux';
import { Languages } from '../../../../settings/components/sections/satisfaction/components/Languages';
const mapStateToProps = (state) => {
    const { globalLevel } = state.settings.satisfaction.customization.widgetchat;
    const { values } = globalLevel;
    return {
        defaultLanguageCode: values === null || values === void 0 ? void 0 : values.language,
    };
};
export default connect(mapStateToProps)(Languages);
